import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import "../../sass/components/Filters/RequiredAvailabilityFilter.scss";

const HOURS_OPTIONS = ["3", "5", "10", "20", "40", "60", "80", "100"];

export default function RequiredAvailabilityFilter({
  value,
  setValue,
  open,
  setOpen,
  title = "Weekly Availability",
  isAdd,
}: {
  value: number;
  setValue: (newState: number) => void;
  open: boolean;
  setOpen: (key: string) => void;
  title?: string;
  isAdd?: boolean;
}) {
  const handleOpen = () => {
    setOpen("requiredAvailability");
  };

  return (
    <div className="component">
      <div onClick={handleOpen} className="heading">
        <p className="title">{title}</p>
        <p>
          {open ? (
            <i className="fas fa-angle-down rotate"></i>
          ) : (
            <i className="fas fa-angle-down"></i>
          )}
        </p>
      </div>
      {open && (
        <div
          className="show_component"
          style={
            isAdd
              ? {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  left: 0,
                  right: 0,
                  borderLeft: 0,
                  borderRight: 0,
                }
              : {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }
          }
        >
          <Autocomplete
            freeSolo={false} // NIE pozwalaj na wpisywanie dowolnej wartości
            options={HOURS_OPTIONS}
            value={
              HOURS_OPTIONS.includes(value?.toString())
                ? value?.toString()
                : null
            }
            onChange={(_, val) => {
              if (!val) {
                setValue(0);
              } else {
                const num = Number(val);
                setValue(!isNaN(num) && num > 100 ? 100 : num);
              }
            }}
            onInputChange={(_, val) => {
              if (!val) {
                setValue(0);
              } else {
                const num = Number(val);
                setValue(!isNaN(num) && num > 100 ? 100 : num);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Hours per week"
                placeholder="At Least"
                type="number"
                variant="outlined"
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <InputAdornment position="end">h</InputAdornment>
                  ),
                  style: {
                    borderRadius: 12,
                    background: "#fff",
                    minWidth: 100,
                    maxWidth: 100,
                  },
                }}
                style={{
                  borderRadius: 12,
                  background: "#fff",
                  minWidth: 100,
                  maxWidth: 100,
                }}
                onKeyDown={(e) => {
                  const input = e.currentTarget as HTMLInputElement;
                  if (
                    (e.key === "Backspace" || e.key === "Delete") &&
                    input.value === ""
                  ) {
                    setValue(0);
                  }
                  if (e.key === "Enter" && input.value === "") {
                    setValue(0);
                  } else if (e.key === "Enter" && Number(input.value) > 100) {
                    setValue(100);
                  }
                }}
              />
            )}
            ListboxProps={{
              style: {
                maxHeight: 200,
                borderRadius: 12,
                minWidth: 100,
                maxWidth: 100,
              },
            }}
          />
        </div>
      )}
    </div>
  );
}
